import React from "react";
import { Phone, Instagram, Mail } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";
import { Wordmark } from "@/components/sections/Navbar";

export const Footer = () => {
  const { content } = useSiteContent();
  const insta = (content.contact_instagram || "").replace(/^@/, "");

  return (
    <footer className="bg-[#0A2342] text-[#FDFBF7] pt-20 pb-10 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #FDFBF7 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="lg:col-span-6">
            <div className="footer-wordmark">
              {content.logo_image ? (
                <img
                  src={content.logo_image}
                  alt="Logo"
                  className="h-16 w-auto object-contain"
                />
              ) : (
                <Wordmark content={content} size="lg" />
              )}
            </div>
            <p className="mt-4 text-[#CBA358] uppercase tracking-[0.22em] text-xs font-semibold">
              {content.tagline}
            </p>
            <p className="mt-6 max-w-md text-[#E5DFD3] leading-relaxed">
              {content.footer_description}
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#CBA358] mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:text-[#CBA358] transition-colors">About</a></li>
              <li><a href="#process" className="hover:text-[#CBA358] transition-colors">How it works</a></li>
              <li><a href="#founder" className="hover:text-[#CBA358] transition-colors">Founder</a></li>
              <li><a href="#testimonials" className="hover:text-[#CBA358] transition-colors">Stories</a></li>
              <li><a href="#faq" className="hover:text-[#CBA358] transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#CBA358] mb-4">Get In Touch</div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${content.contact_phone_tel || "+917055744980"}`}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-3 hover:text-[#CBA358] transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {content.contact_phone}
                </a>
              </li>
              <li>
                <a
                  href={`https://instagram.com/${insta}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-3 hover:text-[#CBA358] transition-colors"
                >
                  <Instagram className="w-4 h-4" />
                  @{insta}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${content.contact_email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 hover:text-[#CBA358] transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {content.contact_email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#E5DFD3]/70">
          <div>
            © {new Date().getFullYear()} {content.logo_text_primary}{content.logo_text_accent} · All rights reserved
          </div>
          {content.footer_closing_quote && (
            <div
              style={{ fontFamily: content.footer_closing_quote_font || '"Great Vibes", cursive' }}
              className="text-2xl text-[#CBA358] tracking-normal"
            >
              {content.footer_closing_quote}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
